import { roles } from '../constant/constant';

export class ForgotPassword {
    userid: string;
    role: roles;
    recaptcha: string;
}

export class ForgotPasswordToken {
    user_guid: string;
    e_password: string;
    confirm_password: string;
    token: string;
    retry: boolean;
    service_id: string;
    role: roles;
}
